import React, {useCallback, useState} from "react";
import MainLayout from 'common/layouts/MainLayout'
import AuthForm from "modules/User/components/AuthForm";
import HeaderPartner from "shared/HeaderPartner";
import ContentMediaView from "shared/ContentMediaView";
import navRoute from "helper/navRoute";
import {links} from "helper";


const AuthPage = ({}) => {
    const navigation = navRoute()
    const onGo = useCallback(() => {
        navigation.home();
    }, [])

    return (
        <MainLayout  data-cy={'auth-page'}>
            <HeaderPartner
                backCkick={onGo}
                head="Авторизация"
                headColor="black"
                items={null}
                mb="3"
            />
            <ContentMediaView view={'mobile'}>
                <AuthForm />
            </ContentMediaView>
        </MainLayout>
    );
};


/*Partners.getInitialProps = wrapper.getInitialPageProps(store => async ({pathname, req, res}) => {
    if (!req) {
        return
    }

    //await store.dispatch(Partner.store.actions.partners.sync({limit: 20}))
});*/

export default AuthPage